import './_photo-gallery-styles.scss';
import './photo-gallery';
